export const GET_ATTRIBUTE_BY_CODE = 'GET_ATTRIBUTE_BY_CODE';
export const REMOVE_ATTRIBUTES_FROM_STATE = 'REMOVE_ATTRIBUTES_FROM_STATE';

export const getAttribute = (attribute) => ({
    type: GET_ATTRIBUTE_BY_CODE,
    attribute
});

export const removeAttributesFromState = () => ({
    type: REMOVE_ATTRIBUTES_FROM_STATE
})
